import type { IconData } from '@stacksjs/iconify-core'

export const tabletCapsuleSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M32.818 1.503c3.454-.075 6.838 1.267 9.625 4.053s4.128 6.17 4.053 9.625c-.074 3.438-1.547 6.823-4.165 9.669a287 287 0 0 1-7.52 7.838l-19.5-19.5c3.108-3.085 5.7-5.553 7.838-7.52c2.846-2.618 6.232-4.09 9.67-4.165M13.19 15.31a287 287 0 0 0-7.522 7.84c-2.618 2.845-4.09 6.23-4.165 9.668c-.075 3.454 1.267 6.838 4.053 9.625s6.17 4.128 9.625 4.053c3.438-.074 6.823-1.547 9.669-4.165a287 287 0 0 0 7.84-7.522z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default tabletCapsuleSolid
